module.exports = __webpack_public_path__ + "static/media/4.5c72d177.JPG";